import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import Ticket from '../pages/user/eTicketRecipt/Ticket'
import { downloadTicket, getTicketDetails } from '../redux/actions/eTicketRecipt'
import { EMPTY_ARRAY, EMPTY_OBJECT } from './globalConstants'
import { errorMessage } from './errorMessage'

function TicketModal(props) {
    const { setTicketModal, ticketModal, selItem, dispatch, loaderDownload, notify, ticketDetails, setTicketDetails } = props

    useEffect(() => {
        if(selItem?.ticket_number){
            getdetails()
        }
        
    },[EMPTY_ARRAY, selItem])

    const getdetails = () => {
        const payload = {
            'ticket': selItem?.ticket_number,
            'phone': '',
            'cardLast4': '',
            'cardExpiry': '',
            'license_plate': '',
            'partner_id': selItem?.partner_id,
        }
        dispatch(getTicketDetails(payload)).then((res) => {
            if (res?.status === 201 || res?.status === 200) {
                if (res?.data && res?.data != null) {
                    
                    // notify('success', 'T successfully')
                    setTicketDetails(() => {
                        setTicketModal(true)
                        return res?.data
                    })
                    // setTicketDetails(res?.data)
                    // setAmount(res?.data?.payable_amount ? res?.data?.payable_amount : '0.00')
                } else {
                    setTicketModal(false)
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                }
            } else {
                setTicketModal(false)
                //  setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            }
        }).catch(() => {
            setTicketModal(false)
            notify('error', errorMessage?.somethingWentWrong)
        })
    }
    const handleDownloadTicket = () => {
        if (!loaderDownload) {
            let ticket_number = selItem?.ticket_number || ticketDetails?.ticket_number
            let partner_id = selItem?.partner_id || ticketDetails?.partner_id
            dispatch(downloadTicket(ticket_number, partner_id)).then((res) => {
                if (res?.status && res?.status == 500) {
                    notify('error', 'Something went wrong, Please try again!')
                }
                notify('Success', 'E-Ticket Downloaded')
            }).catch(() => {
                notify('error', 'Something went wrong, Please try again!')
            })
        }
    }
    const closeTickeModal = () => {
        setTicketModal(false)
    }
    return (
        <>
            <Modal show={ticketModal} onHide={() => closeTickeModal()} centered size="lg" >
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 modal-title h5 fw-bold'>Ticket Details <i className='fa fa-download me-3 float-end mt-1' onClick={() => handleDownloadTicket()}></i></Modal.Title>
                </Modal.Header>
                <Modal.Body><Ticket ticketId={selItem?.ticket_number} ticketDetailsFromProps={ticketDetails} notify={notify} setTicketModal={setTicketModal} ticketModal={ticketModal}/></Modal.Body>
            </Modal>
        </>
    )
}

TicketModal.propTypes = {
    dispatch: PropTypes.func,
    setTicketModal: PropTypes.func,
    ticketModal: PropTypes.bool,
    selItem: PropTypes.object,
    loaderDownload: PropTypes.bool,
    notify: PropTypes.func,
    ticketDetails: PropTypes.object, 
    setTicketDetails: PropTypes.func
}

TicketModal.defaulProps = {
    dispatch: noop,
    setTicketModal: noop,
    ticketModal: false,
    selItem: {},
    loaderDownload: false,
    notify: noop,
    ticketDetails: EMPTY_OBJECT, 
    setTicketDetails: noop
}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(TicketModal)